export enum MapViewState {
  Default = 1,
  Theatre = 2,
  Input = 3,
  Weather = 4,
  Terrain = 5,
  AAR = 6,
}
